module.exports = __webpack_public_path__ + "img/weather_station.ba5fa3d0.png";